import React from 'react';

import ReportModal from 'js/canonical_cards/work_card/modals/report_modal';
import renderModal from 'js/utils/renderModal';
import routes from 'js/core_pre_webpack/routes';
import { Work } from './hooks/types';
import { getCsrfToken } from './util';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { showBulkDownloadModal } from 'js/bulk_download/show_bulk_download_modal';

const csrfToken = getCsrfToken();

// When a user downloads a related work
export const downloadWork =
  (
    readerMessageLimitReached?: boolean,
    setReaderMessageLimitReached?: (value: boolean) => void,
  ) =>
  (work: Work) => {
    showBulkDownloadModal({
      trigger: 'swp-right-rail-related-work',
      gatedDownload: true,
      work: {
        id: work.id,
        slug: work.slug,
        title: work.title,
        attachment: work.attachments[0],
        authors: work.authors,
      },
      readerMessageLimitReached: readerMessageLimitReached,
      setReaderMessageLimitReached: setReaderMessageLimitReached,
    });
  };

export const messageAuthor = (author: { id: number }) => {
  // @ts-expect-error ts-migrate(2552) FIXME: Cannot find name 'Messages'. Did you mean 'onmessa... Remove this comment to see the full error message
  const modal = new Messages.ModalFormView([author.id]);
  modal.show();
};

export const report = (work: Work, sourceWorkId?: number | string) => {
  const reportWork = (choices: string[], workId: number | string) => {
    // Both submits survey results and creates a RelatedWorkRejection
    fetch(routes.api_v0_survey_submit_path({ subdomain_param: 'api' }), {
      body: JSON.stringify({
        choices,
        extra_data: { work_id: workId },
        freeform: null,
        survey_type: 'swp_sidebar_report_work_survey',
        survey_version: 1,
      }),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      method: 'POST',
    });

    fetchWithCsrf(
      routes.api_v0_related_work_rejections_path({ subdomain_param: 'api' }),
      {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          source: 'swp_sidebar',
          work_id: workId,
          source_id: workId, // rejection came from the sidebar WorkCard
          for_work_id: sourceWorkId,
          category: 'general',
        }),
        method: 'POST',
      },
    );
  };

  renderModal((onClose) => (
    <ReportModal reportWork={reportWork} workId={work.id} onClose={onClose} />
  ));
};
